import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import DeliveryCashService from "../../services/deliverycash/deliverycashservice";
import orderServices from "../../services/orders/orderservice";

interface Props {
  visible: boolean;
  onHide: () => void;
  userID: number;
  userName: string;
  startDate: string;
  endDate: string;
}

const CombinedCashTraceDialog: React.FC<Props> = ({
  visible,
  onHide,
  userID,
  userName,
  startDate,
  endDate,
}) => {
    debugger
  const [receivedData, setReceivedData] = useState([]);
  const [collectedData, setCollectedData] = useState([]);
  const [loading, setLoading] = useState(false);
  debugger

  useEffect(() => {
    if (!visible) return;

    const fetchData = async () => {
      setLoading(true);
      debugger
      try {
        debugger
        const [received, collected] = await Promise.all([
          DeliveryCashService.GetReceivedCashTrace({ userID, startDate, endDate }),
          orderServices.cashandOnlineList({
                    dateFilter: {
                        userId: userID,
                        startDate: new Date(startDate),
                        endDate: new Date(endDate),
                        collectionType: 1
                    }
                    }),
        ]);
        setReceivedData(received || []);
        debugger
        setCollectedData(collected?.collectionList || []);
      } catch (error) {
        console.error("Failed to fetch trace data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [visible, userID, startDate, endDate]);

  const formatDate = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  };

  return (
    <Dialog
      header={`Cash Trace Details`}
      visible={visible}
      onHide={onHide}
      modal
      style={{ width: "80vw" }}
    >
      <h6>Collected Cash Details</h6>
      <DataTable value={collectedData} loading={loading} className="mb-4" emptyMessage="No collected cash found">
        {/* <Column field="senderName" header="Sender" /> */}
        <Column field="orderID" header="Order #" sortable/>
        <Column field="invoiceNo" header="Invoice #" sortable/>
        <Column field="invoiceDate" header="Invoice Date" sortable body={(rowData) => formatDate(rowData.invoiceDate)}/>
        <Column field="courierCharges" header="Courier Charges" sortable/>
        <Column field="handlingCharges" header="Handling Charges" sortable/>
        <Column field="paymentGatewayCharges" header="PaymentGateway Charges" sortable/>
        <Column field="discountAmount" header="Discount Amount" sortable/>
        <Column field="grossAmount" header="Gross Amount" sortable/>
        <Column field="rewardAmount" header="Reward Amount" sortable/>
        <Column field="finalAmount" header="Collected Amount" sortable/>
      </DataTable>

      <h6>Received Cash Details</h6>
      <DataTable value={receivedData} loading={loading} emptyMessage="No received cash found">
        <Column field="requestSenderName" header="Received From" />
        <Column field="amount" header="Amount" />
        <Column field="responseDate" header="Received Date" body={(rowData) => formatDate(rowData.responseDate)} />
      </DataTable>
    </Dialog>
  );
};

export default CombinedCashTraceDialog;
